import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';
import { v4 as uuidv4 } from 'uuid';

import { ScrollToConfigOptions, ScrollToService } from '@services';

@UntilDestroy()
@Component({
  selector: 'spa-page',
  templateUrl: 'page.component.html',
  styleUrls: ['page.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent implements AfterViewInit, OnInit {
  private scrollToService = inject(ScrollToService);

  /**
   * @deprecated Property title has side effects - use titleText instead
   */
  @Input() title = '';
  titleText = input<string>();
  @Input() scrollToTopOnInit = true;

  @Input() subtitle: string | null = null;

  @Input() buttonIcon: string | null = null;

  @Input() padding = true;

  @Output() clickOnButton = new EventEmitter<string | undefined>();

  pageId = uuidv4();

  ngAfterViewInit() {
    this.scrollToHead();
  }

  ngOnInit() {
    if (this.scrollToTopOnInit) {
      this.scrollToHead();
    }
  }

  scrollToHead() {
    if (this.scrollToTopOnInit) {
      const config: ScrollToConfigOptions = {
        target: this.pageId,
        offset: -64,
      };

      this.scrollToService.scrollTo(config);
    }
  }

  onClick(): void {
    this.clickOnButton.emit(this.pageId);
  }
}
